import {Component, EventEmitter, Output} from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';

import {BBS_CATEGORY} from '../../defines/protocol';
import {LayoutMgrService} from '../../services/layout-mgr/layout-mgr.service';
import {OptionService} from '../../services/option/option.service';
import {CordovaService} from "../../services/cordova/cordova.service";

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss'],
  animations: [
    trigger('menuInOut', [
      transition(':enter', [
        style({transform: 'translateX(-100%)'}),
        animate('200ms ease-in', style({transform: 'translateX(0%)'}))
      ]),
      transition(':leave', [
        animate('100ms ease-in', style({transform: 'translateX(-50%)'}))
      ])
    ]),
  ],
})
export class LeftMenuComponent {
  // @Input() showMenu = false;    // TODO: 지울것.
  @Output() hideMenu: EventEmitter<any>;

  BBSCategory = BBS_CATEGORY;

  public get showDonation(): boolean {
    return !this.cordovaSvc.isIOS;
  }

  constructor(
    private option: OptionService,
    private cordovaSvc: CordovaService,
    public lm: LayoutMgrService,
  ) {
    this.hideMenu = new EventEmitter<any>();
  }

  onClose($event: MouseEvent): void {
    console.warn('LeftMenuComponent::onClose()', $event);
    $event.preventDefault();
    $event.stopPropagation();

    this.hideMenu.emit();
    this.lm.showMenu = false;
  }

  public get autoPlay(): boolean { return this.option.autoPlay; }
  public set autoPlay(value: boolean) { this.option.autoPlay = value; }
  public setAutoPlay(value: boolean): void {
    this.autoPlay = value;
  }

  onTouchMove($event: TouchEvent) {
    $event.preventDefault();
    $event.stopPropagation();
  }

  onWheel($event: WheelEvent) {
    $event.preventDefault();
    $event.stopPropagation();
  }
}
